import { useEffect, useMemo } from './hookImpl';
export function domStyled(vdom, className) {
    if (className) {
        if (vdom.props.class) {
            vdom.props.class += ' ' + className;
        }
        else {
            vdom.props.class = className;
        }
    }
    return vdom;
}
export function useMemoWithArgs(func, args) {
    return useMemo(() => func(...args), args);
}
export function effectOnMount(fn) {
    useEffect(fn, []);
}
//# sourceMappingURL=extensions.js.map